import { Fragment, useState } from "react";
import Container from "../../../../../../../widgets/Container";
import StdAttendaceSearchView from "./StdAttendaceSearchView";

const StdAttendanceReportListView = () => {

  const [onAttendanceData, setOnAttendanceData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter students based on search term
  const filteredStudents = onAttendanceData.results?.filter((student) => {
    const fullName = `${student.first_name} ${student.last_name}`.toLowerCase();
    return (
      fullName?.includes(searchTerm.toLowerCase()) ||
      student.member_sn.toString()?.includes(searchTerm)
    );
  });

  // Calculate attendance percentage
  const uniqueNepaliDays = Array.from(
    new Set(
      onAttendanceData?.results
        ?.flatMap((student) => student?.attendance?.map((a) => a.date_ne))
        ?.map((d) => d.split("/")[2]) // Extract day only (like "27" from "2082/03/27")
    )
  )?.sort((a, b) => +a - +b);

  return (
    <Fragment>
      <StdAttendaceSearchView setOnAttendanceData={setOnAttendanceData} />

      <div className="mt-3">
        <Container>
          {/* Header with search */}
          <div className="border-b pb-1">
            <div className="flex justify-between items-center">
              <h2 className="text-md font-semibold font-public-sans">
                Student Attendance Report
              </h2>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search students..."
                className="border rounded px-3 py-1 text-[12px] w-64"
              />
            </div>
          </div>

          {/* Main table */}
          <div className="overflow-x-auto h-[80vh] overflow-y-auto">
            <table className="w-full border font-public-sans border-gray-300 text-[12px]">
              <thead>
                <tr className="bg-gray-100 top-0 sticky z-50">
                  <th className="border border-slate400 px-2 py-1">No.</th>
                  <th className="border border-slate400 px-2 py-1 text-left">
                    Student Name
                  </th>
                  {uniqueNepaliDays.map((day) => (
                    <th
                      key={day}
                      className="border border-slate400 px-2 py-1 text-center"
                    >
                      {day}
                    </th>
                  ))}
                  <th className="border border-slate400 bg-green-200 px-2 py-1 text-center">
                    Total Present
                  </th>
                  <th className="border border-slate400 bg-orange-200 px-2 py-1 text-center">
                    Total Late
                  </th>
                  <th className="border border-slate400 bg-red-200 px-2 py-1 text-center">
                    Total Absent
                  </th>
                  <th className="border border-slate400 bg-pink-200 px-2 py-1 text-center">
                    Total Half Day
                  </th>
                  <th className="border border-slate400 bg-blue-200 px-2 py-1 text-center">
                    Total Leave
                  </th>
                  <th className="border border-slate400 bg-slate200 px-2 py-1 text-center">
                    Total Classes
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents?.map((student, idx) => {
                  // Build a map of day => status
                  const attendanceMap = student.attendance.reduce(
                    (acc, entry) => {
                      const day = entry.date_ne.split("/")[2]; // get only day (e.g., "27")
                      let symbol = "P";
                      if (entry.attend_status === "Absent") symbol = "A";
                      else if (entry.attend_status === "Late") symbol = "T";
                      else if (entry.attend_status === "Leave") symbol = "E";
                      else if (entry.attend_status === "Half Day") symbol = "H";
                      else if (entry.attend_status === "Unexcused")
                        symbol = "U";
                      acc[day] = symbol;
                      return acc;
                    },
                    {}
                  );

                  return (
                    <tr
                      key={student.member_sn}
                      className="hover:bg-gray-200 hover:cursor-pointer"
                    >
                      <td className="border border-slate400 px-2 py-1 text-center">
                        {idx + 1}
                      </td>
                      <td className="border border-slate400 px-2 py-1">
                        {student.first_name} {student.middle_name || ""}{" "}
                        {student.last_name}
                      </td>
                      {uniqueNepaliDays.map((day) => (
                        <td
                          key={day}
                          className="border border-slate400 px-2 py-1 text-center"
                        >
                          {attendanceMap[day] || ""}
                        </td>
                      ))}
                      <td className="border border-slate400 px-2 bg-green-200 py-1 text-center">
                        {student.present_count}
                      </td>
                      <td className="border border-slate400 px-2 bg-orange-200 py-1 text-center">
                        {student.late_count}
                      </td>
                      <td className="border border-slate400 px-2 bg-red-200 py-1 text-center">
                        {student.absent_count}
                      </td>
                      <td className="border border-slate400 px-2 bg-pink-200 py-1 text-center">
                        {student.half_day_count}
                      </td>
                      <td className="border border-slate400 px-2 bg-blue-200 py-1 text-center">
                        {student.leave_count}
                      </td>
                      <td className="border border-slate400 px-2 bg-slate200 py-1 text-center">
                        {student.total_classes}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default StdAttendanceReportListView;
